<template>
  <artmisads-modal  v-model:open="visible" :width="720" :maskClosable="false" :closable="false" :closeIcon="false"
    :footer="null" :header="false" :bodyStyle="{ padding: '0' }" class="link-bonus-modal">
    <div class="modal-content-container">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">
          <p>{{ $t('seller.dashboard.linkBonusTitle') }}</p>
        </div>
        <svg-icon class="icon-app" name="close-cu" @click="handleClose"/>
      </div>
      <div class="modal-body">
        <p class="title">{{ $t('seller.dashboard.linkBonusDear') }}</p>
        <p class="description">
          {{ $t('seller.dashboard.linkBonusP1') }}
        </p>
        <p class="description">
         {{ $t('seller.dashboard.linkBonusP2') }}
        </p>
        <P class="description">
          {{ $t('seller.dashboard.linkBonusP3') }}
        </P>
        <div class="footer-btns">
          <artmisads-button :loading="loading" type="primary" class="get-start-btn" @click="handleGetStart">{{ $t('seller.dashboard.linkBonusAck') }}</artmisads-button>
        </div>
      </div>
    </div> 
      <!-- <div class="modal-footer">
        <a-checkbox v-model:checked="checked">Don't show this again</a-checkbox>
      </div> -->
      <!-- <div class="learn-more">
        <a href="javascript:;" @click="handleLearnMore">Learn more about our bonus program</a>
      </div> -->
    </div>
  </artmisads-modal>
</template>

<script setup>
import i18n from '~/i18n'

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { adminApi } from '../../../../server/index'
import jwt from 'jsonwebtoken';
import { useUserInfoStore } from '../../../../storeData/index';
import SvgIcon from '~/components/SvgIcon.vue'
import { message } from 'ant-design-vue'

const store = useUserInfoStore();
const checked = ref(true)
const router = useRouter()
const visible = ref(false)
const emit = defineEmits(['close'])
const loading = ref(false)
const handleClose = async () => {
  visible.value = false
  if(checked.value){
    try {
    const res = await adminApi.associateCompleted()
    const { success, error, data } = res;
    if (success) {
      const userToken = data.token;
      const userInfo = jwt.decode(userToken);
      const menus = store.userInfo.menus;
      store.setUserInfo(userInfo,userToken,menus);
      visible.value = false
     } else {
      message.error(error)
    }
  } catch (err) {
    console.error('Error:', err);
    message.error(i18n.global.t('seller.msg.operationFailed'))
  }
  }
}

const handleGetStart = async () => {
  loading.value = true
  if(checked.value){
    try {
    const res = await adminApi.associateCompleted()
    const { success, error, data } = res;
    if (success) {
      const userToken = data.token;
      const userInfo = jwt.decode(userToken);
      const menus = store.userInfo.menus;
      store.setUserInfo(userInfo,userToken,menus);
      visible.value = false
      router.push('/seller/publishers?isFirst=true')
      
    } else {
      message.error(error)
    }
  } catch (err) {
    console.error('Error:', err);
    message.error(i18n.global.t('seller.msg.operationFailed'))
  }
  }else{
    visible.value = false
    router.push('/seller/publishers?isFirst=true')
  }
  
  loading.value = false
  emit('close')
}

const showModal = () => {
  visible.value = true
}

defineExpose({
  showModal
})
</script>

<style scoped lang="less">

.link-bonus-modal {
  :deep(.artmisads-modal-content) {
    border-radius: 8px;
    overflow: hidden;
    padding: 24px;
    background-image: url('../../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .modal-content-container{
    // background-color: #FBFBFE;
  }
  .modal-footer {
    text-align: center;
   margin-top: -20px;
   padding-bottom: 18px;
  }
  .modal-content {
    height: 449px;
    text-align: left;
    background-image: url('../../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .modal-header {
      position: relative;
      .icon-app{
        position: absolute;
        right: 24px;
        top: 24px;
        font-size: 24px;
        cursor: pointer;
      }
      .modal-header-title {
        color: #0f0629;
        font-family: "Sora";
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        padding: 24px 40px;
        letter-spacing: 0.69px;
      }
    }

    .modal-body {
      border-radius: var(--Radius-Radius-10, 10px);
      padding: 20px 30px;
      margin: 0 40px;
      border: 1px solid #FFF;
      background: #FFF;
      box-shadow: 0 1px 4px 0 #0000000a, 0 2px 16px 0 #00000014;
      height: 262px;

      .title {
        color: #0f0629;
        font-family: "Sora";
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        margin-bottom: 12px;
      }

      .description {
        color: #0f0629;
        font-family: "PingFang SC";
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 30px;

        // &:nth-child(3) {
        //   margin-bottom: 0;
        // }

      }
    }

    .footer-btns {
      text-align: center;
      margin-top: 40px;

      .artmisads-btn {
        min-width: 120px;
      }
    }

    .learn-more {
      text-align: center;

      a {
        font-size: 14px;
        color: var(--primary-color);
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>